<script>
  export let word
  export let character

  let characters = []

  $: if (word) characters = Array.from(word)
</script>

<div>
  {#each characters as c}
    <span class:highlight={character === c}>{c}</span>
  {/each}
</div>

<style>
  div {
    font-size: inherit;
    line-height: 1em;
    text-align: center;
    display: inline;
    white-space: nowrap;
  }

  span:not(.highlight) {
    opacity: 0.5;
  }

  span.highlight ~ span.highlight {
    opacity: 0.5;
  }
</style>
